import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getSchoolLogoUrl } from '../utils/schoolLogo';

/**
 * Круглый аватар школы (как в соцсетях).
 * @param {string|null} logoPath — путь из API, blob: или полный URL
 * @param {number} size — диаметр в px
 * @param {number|string} [cacheBust] — сброс кэша браузера после загрузки нового фото
 */
export default function SchoolAvatar({ logoPath, size = 40, alt, style = {}, cacheBust }) {
    const { t } = useTranslation('school');
    const altText = alt ?? t('school:nameFallback');
    const [failed, setFailed] = useState(false);
    const url = getSchoolLogoUrl(logoPath, cacheBust);
    const showImage = url && !failed;

    useEffect(() => {
        setFailed(false);
    }, [logoPath, cacheBust]);

    const base = {
        width: size,
        height: size,
        minWidth: size,
        borderRadius: '50%',
        overflow: 'hidden',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #EB3333, #9b59b6)',
        color: 'white',
        fontSize: Math.round(size * 0.42),
        fontWeight: '700',
        flexShrink: 0,
        boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
        ...style
    };

    if (showImage) {
        return (
            <span style={base} title={alt}>
                <img
                    key={url}
                    src={url}
                    alt={alt}
                    onError={() => setFailed(true)}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block'
                    }}
                />
            </span>
        );
    }

    return (
        <span style={base} title={altText} aria-hidden>
            🏫
        </span>
    );
}
